<div class="media-container">
    <div nz-row *ngIf="videos.length || promotionalMaterials.length">
        <nz-card>
            <div class="media-title">
                MEDIA ({{ videos.length + promotionalMaterials.length }})
            </div>
            <div class="media-filter-buttons">
                <div *ngFor="let typeFilter of filterMediaTypeOptions;">
                    <button nz-button class="media-filter-button"
                            [nzType]="typeFilter.value === filterMediaType ? 'primary' : 'default'"
                            (click)="filterByMediaType(typeFilter?.value)">
                        {{ typeFilter?.label }}
                    </button>
                </div>
            </div>
            <div class="media-items">
                <div *ngFor="let media of allMaterials | mediaFilter: filterMediaType">
                   <leap-media-card [media]="media" [type]="media.type"></leap-media-card>
                </div>
            </div>
        </nz-card>
    </div>
    <div nz-row *ngIf="!videos.length && !promotionalMaterials.length">
        <nz-card>
            No media available for this product.
        </nz-card>
    </div>
</div>

